import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { adminUpdateUserApi, checkIsValidEmail, checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import { Container, AccordionHeader, AccordionBody, InputFieldsWrapper } from '.././PTPlusStyled'
import TextInput from 'web/components/form-elements/TextInput';
import PhoneNumber from 'web/components/form-elements/PhoneNumber';
import NumberInput from 'web/components/form-elements/NumberInput';
import EditIcon from "web/assets/svg/PtPlusUserViewEditIcon";
import { storeAdminDetails, logoutAdmin} from 'redux/actions/admin';
import AlertModal from 'web/components/AlertModal';

function BasicInfo(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const [saveDisableState, setSaveDisableState] = useState(true)
    const [isValidEmail, setIsValidEmail] = useState(true)
    const [isValidZip, setIsValidZip] = useState(true)
    const [accordionOpen, setAccordionOpen] = useState(true)
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');
    let pageFieldValues = pageProps.formikProps.values

    useEffect(() => {
        let fieldValues = pageProps.formikProps.values       
        if (!pageProps.formikProps.errors.phoneNumber  && isValidZip && fieldValues.userName?.trim() !== '' && fieldValues.phoneNumber?.trim() !== '' && fieldValues.businessName?.trim() !== '' && fieldValues.email?.trim() !== '' &&
            fieldValues.address?.trim() !== '' && fieldValues.city?.trim() !== '' && fieldValues.state?.trim() !== '' && fieldValues.zip?.trim() !== '' && parseInt(fieldValues.zip) > 0) {
            setSaveDisableState(false)
        } else setSaveDisableState(true)
    }, [pageProps.formikProps, isValidEmail, isValidZip])

    const updateApiFunction = async () => {
        let id = pageProps.pageData.id
        let url = `ptms/internal/basic_info_update/${id}`
        let fieldValues = pageProps.formikProps.values
        let response = '';
        let data = {
            contactNumber: fieldValues.phoneNumber?.trim(),
            customerName: fieldValues.userName?.trim(),
            locationName: fieldValues.businessName?.trim(),
            emailAddress: fieldValues.email?.trim(),
            address: {
                name: fieldValues.businessName?.trim(),
                contactNumber: fieldValues.phoneNumber?.trim(),
                locationName: fieldValues.businessName?.trim(),
                street: fieldValues.address?.trim(),
                city: fieldValues.city?.trim(),
                state: fieldValues.state?.trim(),
                zipCode: fieldValues.zip?.trim()
            }
        }
        const token = localStorage.getItem('token')
        response = await dispatch(adminUpdateUserApi(url, data, token))
        if (response.success) {
            setAlertModalContent('Detail has been updated successfully.')
            setAlertModal(!alertModal)
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message)
                setAlertModal(!alertModal)
            }
        }
    }

    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
        window.location.reload(false);
    }
    const zipChangeHandler = async (value) => {
        const token = localStorage.getItem('token')
        let response = '';
        if (value.length === 5) {
            response = await dispatch(checkIsZipCode(value, token))
            if (response.success) {
                setIsValidZip(true)
                //let stateAbb = stateConvert(response.data?.state)
                // pageProps.setFieldValue('state', stateAbb || response.data?.state)
                pageProps.setFieldValue('state', stateConvert(response.data?.state) || response.data?.state)
                pageProps.setFieldValue('city', response.data?.city)
            } else {
                if (response?.data?.error?.message === 'Invalid Zip Code.') {
                    setIsValidZip(false)
                    pageProps.setFieldValue('state', '')
                    pageProps.setFieldValue('city', '')
                } else if (response.statusCode === 401) {
                    adminLogout()
                } else {
                    setAlertModalContent(response.message || 'Something went wrong, please try again.')
                    setAlertModal(!alertModal)
                }
            }
        } else {
            setIsValidZip(true)
            pageProps.setFieldValue('state', '')
            pageProps.setFieldValue('city', '')
        }
    }

    const resetFieldsFunction = () => {
        const initailData = pageProps.pageData
        pageProps.setFieldValue('phoneNumber', initailData.contactNumber)
        pageProps.setFieldValue('userName', initailData.customerName)
        pageProps.setFieldValue('email', initailData.emailAddress)
        pageProps.setFieldValue('businessName', initailData.locationName)
        pageProps.setFieldValue('address', initailData.locationAddress?.street)
        pageProps.setFieldValue('city', initailData.locationAddress?.city)
        pageProps.setFieldValue('state', initailData.locationAddress?.state)
        pageProps.setFieldValue('zip', initailData.locationAddress?.zipCode)
    }

    return (
        <>
            <Container>
                <AccordionHeader>
                    <h6 onClick={() => {
                        if(accordionOpen) setAccordionOpen(false)
                        else setAccordionOpen(true)
                    }}>Company Profile</h6>
                    {accordionOpen ?
                        <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
                        : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
                    }
                </AccordionHeader>
                {accordionOpen &&
                    <AccordionBody>
                        <InputFieldsWrapper>
                            <div className="row">
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.businessName !== '' && <h6>Company Name<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name='businessName' placeholder={`Company Name*`} inputType='companyAndLocationText' /></div>
                                </div>
                                <div className={!isValidEmail ? 'col-md-4 fixed-height error-styling-input' : 'col-md-4 fixed-height'}>
                                    {pageFieldValues.email !== '' && <h6>Email<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name="email" disabled placeholder={`Email*`} />
                                        {!isValidEmail && <p style={{ marginTop: '-7px' }}>Email already exists.</p>}
                                    </div>
                                </div>
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.address !== '' && <h6>Address<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name='address' placeholder={`Address*`} maxLength={200}/></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.city !== '' && <h6>City<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name="city" placeholder={`City*`} inputType='text' /></div>
                                </div>
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.state !== '' && <h6 className='mb-2'>State<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name="state" placeholder={`State*`} disabled inputType='text' /></div>
                                </div>
                                <div className={!isValidZip ? 'col-md-4 fixed-height error-styling-input' : 'col-md-4 fixed-height'}>
                                    {pageFieldValues.zip !== '' && <h6 className='mb-2'>Zip<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><NumberInput name="zip" placeholder={`Zip*`} maxLength={5} callBackFlag={true} callBackFun={zipChangeHandler} />
                                        {!isValidZip && <p style={{ marginTop: '-12px' }}>Zipcode is invalid.</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.phoneNumber !== '' && <h6>Company Phone Number<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><PhoneNumber name="phoneNumber" placeholder={`Company Phone Number*`} /></div>
                                </div>
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.userName !== '' && <h6>Contact Full Name<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name='userName' placeholder={`Contact Full Name*`} inputType='text' /></div>
                                </div>
                            </div>
                        </InputFieldsWrapper>
                        <div className='view-edit-button-section'>
                            <button className={saveDisableState ? 'save-button disabled' : 'save-button'} disabled={saveDisableState} onClick={() => updateApiFunction()}><EditIcon />Update</button>
                            <button className='cancel-button' onClick={() => resetFieldsFunction()}>Cancel</button>
                        </div>
                    </AccordionBody>
                }
            </Container>

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                title=''
                content={alertModalContent}
            />
        </>
    )
}

export default BasicInfo